var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12114_3778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 7.33325C12.4467 7.33325 12.56 7.33992 12.6667 7.35325V4.57992C12.6667 3.89325 12.1067 3.33325 11.42 3.33325H2.58004C1.89337 3.33325 1.33337 3.89325 1.33337 4.57992V11.4199C1.33337 12.1066 1.89337 12.6666 2.58004 12.6666H9.06671C8.81337 12.1666 8.66671 11.5999 8.66671 10.9999C8.66671 8.97325 10.3067 7.33325 12.3334 7.33325ZM6.93337 8.66659L2.66671 6.12659V4.66659H2.82004L6.94004 7.11992L11.16 4.66659H11.3334V6.10659L6.93337 8.66659Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 8.6665L11.7267 9.6065L12.78 10.6665H10V11.9998H12.78L11.7267 13.0598L12.6667 13.9998L15.3333 11.3332L12.6667 8.6665Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12114_3778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/SendEmail.796f1c88fb4edb33c1f5758c3d070931.svg";
export { ForwardRef as ReactComponent };